import {
    Card,
    CardContent,
    Grid,
    TextField,
    IconButton,
    Container,
    Dialog,
    DialogTitle,
    Divider,
} from '@mui/material'
import { Formik } from 'formik'
import React, { useState } from 'react'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

function UnitsCreateAndUpdateDailog({
    visible,
    unitData,
    onSubmit,
    onClose,
    initialValue,
    title,
    okText,
}) {


    const [value, setValue] = useState(0)

    const handleTabChange = (event, newValue) => {
        setValue(newValue)
    }

    if (initialValue == undefined)
        initialValue = {
            name: '',
        }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Required').max(3, 'Max length is 3 character'),
    })

    const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    const onDialogClose = () => {
        setValue(0)
        onClose()
    }

    return (
        <div>
            <Dialog maxWidth={'sm'} anchor="right" backdrop="static" variant="temporary" open={visible}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onDialogClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        initialValues={initialValue}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                            setFieldValue
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card >
                                    <CardContent>
                                        <Grid container spacing={5} style={{ paddingTop: 10 }}>
                                            <Grid item md>
                                                <TextField
                                                    size='small'
                                                    name="name"
                                                    label="Name"
                                                    value={values.name}
                                                    margin="dense"
                                                    error={Boolean(touched.name && errors.name)}
                                                    fullWidth
                                                    helperText={touched.name && errors.name}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item>
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div>
    )
}

export default UnitsCreateAndUpdateDailog
